import { useMutation } from "@tanstack/react-query";
import { useApi, useAuth } from "../../../hooks";


export const useCoachLogin = () => {
  const { api } = useApi({ throwIfError: true });
  const { userToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async (email: string | undefined) => {
      const nonce = parseInt(
        String(Math.random() * 1000 * (Math.random() * 1000))
      );

      const route = `/dashboard/login/${nonce}`;

      const payload: any = {
        email,
      };

      return await api({
        route,
        token: userToken,
        method: "POST",
        payload,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
    },
  });

  return { mutation };
};
